export enum EEnvironment {
  LOCAL_DEVELOPMENT = "LOCAL_DEVELOPMENT",
  DEVELOPMENT = "DEVELOPMENT",
  STAGING = "STAGING",
  PRE_PROD = "PRE_PROD",
  PRODUCTION = "PRODUCTION"
}
